import { render } from "./Notifications.vue?vue&type=template&id=41ffc2e9&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=41ffc2e9&scoped=true&lang=css"

import exportComponent from "/home/heather/Documents/Work/Soldel/pwa2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ffc2e9"]])

export default __exports__